export default function Steps() {
  const steps = [
    {
      number: '01',
      title: 'お問い合わせ',
      description: 'お電話またはWebフォームからお気軽にお問い合わせください。',
      icon: 'ri-mail-send-line',
    },
    {
      number: '02',
      title: 'ご相談・お見積り',
      description: 'お客様のご要望をお伺いし、最適なプランをご提案いたします。',
      icon: 'ri-discuss-line',
    },
    {
      number: '03',
      title: '現地調査',
      description: '設置場所の確認と詳細な調査を行います。',
      icon: 'ri-search-eye-line',
    },
    {
      number: '04',
      title: '設置工事',
      description: '専門スタッフが丁寧に設置工事を行います。',
      icon: 'ri-tools-line',
    },
    {
      number: '05',
      title: 'ご利用開始',
      description: 'ウルトラファインバブル水のある快適な生活をお楽しみください。',
      icon: 'ri-home-smile-line',
    },
  ];

  return (
    <section id="steps" className="py-24 bg-white relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-transparent to-cyan-50 opacity-50"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <p className="text-blue-500 font-semibold text-sm uppercase tracking-wider mb-2">STEPS</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">ご依頼の流れ</h2>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-blue-200 via-blue-400 to-blue-200 -translate-y-1/2"></div>

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-2xl shadow-xl p-6 hover:shadow-2xl transition-shadow relative z-10">
                  <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-blue-500 to-cyan-500 text-white rounded-full mx-auto mb-4 text-2xl">
                    <i className={step.icon}></i>
                  </div>
                  <div className="text-center mb-4">
                    <span className="text-4xl font-bold text-blue-500">{step.number}</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">{step.title}</h3>
                  <p className="text-sm text-gray-600 text-center leading-relaxed">{step.description}</p>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-8 -right-4 w-8 h-8 flex items-center justify-center text-blue-500 text-2xl z-20">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl p-8 max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">お気軽にご相談ください</h3>
            <p className="text-gray-600 mb-6">
              ご不明な点やご質問がございましたら、お気軽にお問い合わせください。<br />
              専門スタッフが丁寧にご対応いたします。
            </p>
            <a
              href="#contact"
              className="inline-block bg-blue-500 text-white px-8 py-3 rounded-full hover:bg-blue-600 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              お問い合わせはこちら
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
